<div class="request-for-approvals-container">
   <nb-tabset (changeTab)="onTabChange($event)" style="height: 100%;">
    <nb-tab tabTitle="Approvals & Reminders" style="padding: 0 !important;">
        <div class="request-for-approvals-body" fxLayout="column">
          <div style="display: flex;flex-direction: column;" [ngStyle]="containerHeightStyle">
            <ng-container *ngIf="emptyAttendanceDataRequest && emptyLeaveDataRequest && emptyCarDataRequest && emptyAccommodationDataRequest 
                && !attendanceRequestLoading && !leaveRequestLoading && !carRequestLoading && !accommodationRequestLoading && !remindersLoadingData && !remindersData?.length 
                && !synergyLoadingData && !synergyApprovals?.length">
                <div class="empty-data" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
                    <div>
                        <img height="80"
                            [src]="EmptyState"
                            alt="Empty">
                    </div>
                    <span>No Pending Requests found.</span>
                </div>
            </ng-container>
            <ng-container *ngIf="attendanceRequestLoading">
                <div fxFlex="100" fxLayout="column">
                    <div class="request-list-container">
                        <div class="shimmer-wrapper">
                            <div class="shimmer-card">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ltts-approval-v2 [approvalData]="reqForAttendanceApprovalsData"
                (fetchRequest)="fetchAttendanceRequestForApprovalData()"
                (accordionStateChange)="onAccordionStateChange($event)"></ltts-approval-v2>
         

            <ng-container *ngIf="leaveRequestLoading">
                <div fxFlex="100" fxLayout="column">
                    <div class="request-list-container">
                        <div class="shimmer-wrapper">
                            <div class="shimmer-card">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ltts-approval-v2 [approvalData]="reqForLeaveApprovalData" 
                (fetchRequest)="fetchLeaveRequestForApprovalData()"
                (accordionStateChange)="onAccordionStateChange($event)">
            </ltts-approval-v2>

            <ng-container *ngIf="synergyLoadingData">
                <div fxFlex="100" fxLayout="column">
                    <div class="request-list-container">
                        <div class="shimmer-wrapper">
                            <div class="shimmer-card">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ltts-approval-v2 *ngIf="isSynergyApprover && !synergyLoadingData && synergyApprovals?.length"
                [approvalData]="synergyApprovals" 
                (fetchRequest)="fetchSynergyRequestForApprovalData()"
                (accordionStateChange)="onAccordionStateChange($event)">
            </ltts-approval-v2>

            <ltts-forex *ngIf="showForex" [forexReqForApprovalsData]="forexData" [forexRequestsDataLoading]="forexLoadingData"></ltts-forex>
            <ltts-reminders-v2 [reminders]="remindersData" [remindersLoading]="remindersLoadingData"></ltts-reminders-v2>

            </div>
           <!-- Notify Section -->
            <div class="notify-section">
             <div class="training-panel" role="region" aria-label="ISMS & DP Training" *ngIf="!(hasActiveISMS && hasActiveDataPrivacy)">
                <div class="ismsInfoIcon">
                  <a [routerLink]="'feed-details/143'" (click)="cancelClicked()"><img src="/assets/images/approvals/Info.svg" alt="img" /></a>
                  
                </div>
                <div class="panel-header">
                  <h3 class="panel-title">ISMS and DP Training Status</h3>
                </div>

                <div class="cards-flex">
                  <div class="cards-row">
                    <div class="mini-card">
                      <div class="card-top card-top--blue">ISMS</div>

                      <div class="card-body">
                        <span class="status">
                          <span class="dot">
                            <img class="dot-icon"
                              [src]="hasActiveISMS ? 'assets/images/complete.svg' : 'assets/images/error.svg'"
                              [alt]="hasActiveISMS ? 'Completed' : 'Pending'" />
                          </span>

                          {{ hasActiveISMS ? 'Completed' : 'Pending' }}
                        </span>
                      </div>
                    </div>
                    <div class="mini-card">
                      <div class="card-top card-top--blue">DP</div>
                      <div class="card-body">
                        <span class="status">
                          <span class="dot">
                            <img class="dot-icon"
                              [src]="hasActiveDataPrivacy ? 'assets/images/complete.svg' : 'assets/images/error.svg'"
                              [alt]="hasActiveDataPrivacy ? 'Completed' : 'Pending'" />
                          </span>
                      {{ hasActiveDataPrivacy ? 'Completed' : 'Pending' }}
                        </span>
                      </div>
                    </div>
                 </div>
                </div>

                <div class="wide-card">
                  <div class="title">Overall Status</div>
                  <p><b>{{completedCount}}</b> out of 2 completed <a class="quiz-link"
                      href='https://performancemanager10.successfactors.com/sf/learning?destUrl=https%3a%2f%2flttechnolo%2eplateau%2ecom%2flearning%2fuser%2fdeeplink%5fredirect%2ejsp%3flinkId%3dPROGRAM%5fDETAILS%26programID%3dISMS%2band%2bData%2bPrivacy%2b2025%2d26%26fromSF%3dY&company=LTTS'
                      target='_blank'>Click here</a> to access and complete it.</p>
                </div>
              </div>
              <div class="quizInfoSection" *ngIf="hasActiveQuiz && showQuizNotify">
                <div class="quizInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  InQuizitive
                </div>
                <div class="notify-text">
                  <p>You have a pending quiz. <a  class="quiz-link" (click)="navigateToUrl('/quiz')">Click here</a> to access and complete it.</p>
                </div>
              </div>
                <div class="quizInfoSection" *ngIf="appraisalData">
                <div class="quizInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  Access Temporarily Restricted
                </div>
                <div class="notify-text">
                  <p>Your Outlook and Teams access has been temporarily restricted due to pending self assessment/IS reviews. Please complete these required appraisal activities to restore access. <a  class="quiz-link" href='https://performancemanager10.successfactors.com/sf/pmreviews?bplte_company=LTTS&_s.crb=sD%252fUrUyPwqvVLOngSTT2Dj4o4GHT%252fA3DNv3m39fZqHA%253d#/'
                      target='_blank'>Click here</a> to access and complete it.</p>
                </div>
              </div>
              <div class="quizInfoSection" *ngIf="talentAIData">
                <div class="quizInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  Talent AI
                </div>
                <div class="notify-text">
                  <p>Talent AI is Now Live. <a class="quiz-link" [routerLink]="'/talentai'" (click)="cancelClicked()">Click here </a> to access and update your skills. </p>
                </div>
              </div>
              <div class="townhallInfoSection" *ngIf="hasActiveTownhall && showTownhallNotify">
                <div class="townhallInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  Town Hall
                </div>
                <div class="notify-text">
                  <p>We're excited to announce our townhall <a [routerLink]="'/townhall'" class="townhall-link" (click)="cancelClicked()">Click here</a> to share your questions and help shape the conversation</p>
                </div>
              </div>
              <div class="infoSection">
                <div class="infoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="reminder-text">
                  <span style="color:#000000;font-weight:bold;font-size:15px">Available Reminders</span>
                  <ol>
                    <li>Project Expiry</li>
                    <li>Visa Expiry</li>
                  </ol>
                </div>
                <span class="approvalText">Available Approvals</span>
                <ol class="list-of-approvals">
                  <!-- <li>Accommodation</li> -->
                  <li>Attendance</li>
                  <!-- <li>Cab</li> -->
                  <li>Leave</li>
                  <li>Synergy</li>
                  <li>Forex</li>
                </ol>
              </div>
              </div>
        </div>
    </nb-tab>
    <nb-tab tabTitle="My Request" class="notification-onediv" style="padding: 0 !important;">
        <!-- <ltts-my-request-attendance [myRequest]="myRequestData"></ltts-my-request-attendance> -->
         <div class="my-request-tab">
                <ltts-my-request-attendance style="display: flex;flex-direction: column;height: 100%;justify-content: space-between;" *ngIf="myRequestData" 
                    [myRequest]="myRequestData"
                    [hasActiveISMS]="hasActiveISMS"
                    [hasActiveDataPrivacy]="hasActiveDataPrivacy"
                    [completedCount]="completedCount"
                    [notifications]="notifications"
                    [hasActiveQuiz]="hasActiveQuiz"
                    [showQuizNotify]="showQuizNotify"
                    [hasActiveTownhall]="hasActiveTownhall"
                    [showTownhallNotify]="showTownhallNotify"
                    (collapseSidenavEvent)="cancelClicked()"
                    (navigateToUrlEvent)="navigateToUrl($event)">
                </ltts-my-request-attendance>
                
            </div>

    </nb-tab>
   </nb-tabset>

    
    
    
</div>